import React, { useMemo } from 'react'

import { SingleAsyncSelect } from '../Select'

import apiClient from '../../helpers/apiClient'

import { debounce } from '../../utils/util'

const AsyncSingleCitySelect = ({
  city,
  onSelectCity,
  country,
  validationError,
}) => {
  const debouncedFetchCitiesOfCountry = useMemo(() => {
    return debounce((name, resolve, reject) => {
      apiClient
        .get(`/country/city?country=${country}&name=${name}`)
        .then((res) => {
          const cities = res?.data?.data?.map((e) => ({
            value: e.name,
            label: e.name,
          }))
          resolve(cities)
        })
        .catch((err) => reject(err))
    }, 500)
  }, [country])

  const fetchCitiesOfCountry = (name) => {
    return new Promise((resolve, reject) => {
      debouncedFetchCitiesOfCountry(name, resolve, reject)
    })
  }

  return (
    <SingleAsyncSelect
      title="City"
      loadingMessage="Fetching cities..."
      selected={city}
      promiseOptions={fetchCitiesOfCountry}
      placeholder="Start typing a city..."
      onChange={onSelectCity}
      wrapperClass={validationError && 'error'}
      subText={validationError}
    />
  )
}

export default AsyncSingleCitySelect
